export default "__VITE_ASSET__b72a2c81__"